// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__27ZGr","calendarButtons":"ClockData_calendarButtons__3tGXm"};